import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-rating-critics",
  "use": "foquz-icon-rating-critics-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"foquz-icon-rating-critics\"><circle cx=\"7.136\" cy=\"8.773\" r=\"1.227\" fill=\"#F96261\" /><circle cx=\"12.864\" cy=\"8.773\" r=\"1.227\" fill=\"#F96261\" /><path d=\"M12.982 13.737a4.09 4.09 0 00-5.785-.043M5.265 6.95l3.175.794m6.295-.794l-3.175.794M19 10a9 9 0 11-18 0 9 9 0 0118 0z\" stroke=\"#F96261\" stroke-width=\"2\" stroke-linecap=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol